import { useState } from "react";
import _ from "lodash";

import useMount from '../../hooks/useMount';
import LoadingComponent from "../Commons/LoadingComponent";
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";

import { MdStar } from "react-icons/md";
import { getLabel } from "../../tools/Dictionary";

const InitDesignerModal = (props) =>
{

  //Props
  const Variable = props.Variable;
  const OnChangeVariable = props.OnChangeVariable;
  const OnCloseModal = props.OnCloseModal;

  //State
  const [form, setForm] = useState({

  });
  const [error, setError] = useState({

  });
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm, setConfirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });



  return (
    <div className="page_modal_background">
      <div className="page_modal_cont" style={{ width: "600px" }}>
        <LoadingComponent
          display={loading}
          label={getLabel("App", "Loading")}
        />
        <AlertModal
          Title={alert.Title}
          Message={alert.Message}
          Confirm={alert.Confirm}
          onConfirm={alert.onConfirm}
          Display={alert.Display}
        />
        <ConfirmModal
          Display={confirm.Display}
          Title={confirm.Title}
          Message={confirm.Message}
          Cancel={confirm.Cancel}
          onCancel={confirm.onCancel}
          Confirm={confirm.Confirm}
          onConfirm={confirm.onConfirm}
        />
        <div className="page_modal_header_cont" style={{ marginBottom: "10px" }}>
          {getLabel("InitDesigner", "Choose a variable")}
        </div>
        <div className="page_modal_body_cont">
          {Variable.map((v, indexV) => (
            <div className="init_variable_item" key={indexV} onClick={() => OnChangeVariable(v)}>
              {v.isParameter &&
                <div className="init_variable_item_icon" title={getLabel("InitDesigner", "This variable is a parameter")}>
                  <MdStar />
                </div>
              }
               {v.name}
            </div>
          ))}
        </div>
        <div className="page_modal_footer_cont">
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("App", "Close")}
            style={{ backgroundColor: "grey", maxWidth: "200px" }}
            onClick={(loading && !OnCloseModal) ? undefined : OnCloseModal}
            disabled={loading}
          />
        </div>
      </div>
    </div>
  );

};

export default InitDesignerModal